import { Routes } from '@angular/router';
import { PagenotfoundComponent } from './pages/pagenotfound/pagenotfound.component';
import { SigninOidcComponent } from './pages/signin-oidc/signin-oidc.component';
import { LogoutComponent } from './public/logout/logout.component';
import { NoAccessComponent } from './pages/no-access/no-access.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { InstallationContextGuard } from './guards/installation-context.guard';
import { adminPanelGuard } from './admin-panel/guards/admin-panel.guard';


export const routes: Routes = [
  // {
  //   path: '',
  //   component: PagenotfoundComponent,
  // }
  {
    path: 'signin-oidc',
    component: SigninOidcComponent,
  },
  {
    // When logging you are first redirected to breece logout, 
    //then redirected back to this logout, 
    // then the AutoLoginPartialRoutesGuard handler redirects you to login
    path: 'logout',
    component: LogoutComponent,
  },
    { 
    path: 'access-denied', 
    component: NoAccessComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'not-found',
    component: PagenotfoundComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    // Breece admin panel — a global (non-installation) area, gated to BreeceSupport.
    // Must be matched before the catch-all pages route below.
    path: 'admin',
    loadChildren: () => import('./admin-panel/admin-panel.routes').then(m => m.adminPanelRoutes),
    canActivate: [AutoLoginPartialRoutesGuard, adminPanelGuard],
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.routes').then(m => m.pagesRoutes),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  
  {
    path: '**',
    component: PagenotfoundComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  // TODO: Languages on 404 and 403

];